import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import SiteNavItem from './SiteNavItem';

import styles from './SiteNav-style.scss';

export function SiteNav({ viewer }) {
    const navigation = get(viewer, 'tradeNavigation') || get(viewer, 'navigation') || null;
    return (
        <div className={styles.wrapper}>
            <div className={styles.items}>
                {(get(navigation, 'modules') || []).map(module => {
                    return <SiteNavItem key={module.serviceId} navigationModule={module} />;
                })}
            </div>
        </div>
    );
}

SiteNav.propTypes = {
    viewer: PropTypes.object,
};

export default createFragmentContainer(SiteNav, {
    viewer: graphql`
        fragment SiteNav_viewer on Viewer {
            navigation: navigation(rootId: $previewKey) @include(if: $fetchNav) {
                modules {
                    ...SiteNavItem_navigationModule
                    serviceId
                }
            }
            tradeNavigation: navigation(rootId: $previewKey, userType: TRADE)
                @include(if: $fetchTradeNav) {
                modules {
                    ...SiteNavItem_navigationModule
                    serviceId
                }
            }
        }
    `,
});
